<template>
	<div class="xs-12">
		<!-- Headline -->
		<div class="flex xs-12 xs-between">
			<div class="fs5 lh125 fw7 c1 mb2">{{ $t("facts") }}</div>
			<!-- <j-button
				v-if="canEditApprovedClaims(claimStatus)"
				type="tertiary"
				@click="$modal.show('add_facts')"
			>
				<crm-icon name="add" color="c2" size="small" />
				{{ $t("add") }}
			</j-button>-->
		</div>

		<!--  data -->
		<j-card class="bg5">
			<div v-for="section in Object.entries(schema)" :key="section[0]">
				<div class="xs-12 p4">
					<div class="flex xs-12 lh125 fw7">{{ $t(section[0]) }}</div>
					<div v-for="item in section[1]" :key="item.label" class="xs-12">
						<div class="flex xs-12 pt2 xs-middle wrap">
							<div
								v-if="!item.isContainer && item.label !== 'no_label'"
								class="fw7 fs3 c6 xs-12 pr2 lh125 sm-2"
							>
								{{ item.label }}
							</div>
							<component
								v-if="!item.isContainer"
								:class="item.label !== 'no_label' ? 'xs-12 sm-10' : 'xs-12'"
								:is="item.component"
								v-bind="item.componentProps"
								:value="item.value"
								@input="item.onInput"
								size="xsmall"
							/>
							<!--  subsection -->
							<div
								v-if="item.isContainer"
								class="flex wrap xs-12 b1 r2 bc7 mb1"
							>
								<div
									class="xs-12 sm-4 p2 flex xs-middle xs-center"
									v-for="subItem in item.subItems"
									:key="subItem.label"
								>
									<div class="xs-12">
										<div class="fw7 mr2 fs3 c6 xs-12 ta1 p1">
											{{ subItem.label }}
										</div>
										<!-- double component handle currency + input value -->
										<div v-if="subItem.isDoubleComponent" class="flex xs-12">
											<component
												class="xs-4"
												:is="subItem.firstComponent.component"
												v-bind="subItem.firstComponent.componentProps"
												:value="subItem.firstComponent.value"
												@input="subItem.firstComponent.onInput"
												size="xsmall"
											/>
											<component
												class="xs-8"
												:is="subItem.secondComponent.component"
												v-bind="subItem.secondComponent.componentProps"
												:value="subItem.secondComponent.value"
												@input="subItem.secondComponent.onInput"
												size="xsmall"
											/>
										</div>
										<component
											v-else
											class="xs-12"
											:is="subItem.component"
											v-bind="subItem.componentProps"
											:value="subItem.value"
											@input="subItem.onInput"
											size="xsmall"
										/>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<j-button
				class="m4"
				@click="saveFacts"
				:isLoading="isLoading"
				type="primary"
				size="medium"
				>{{ $t("save") }}</j-button
			>
		</j-card>
	</div>
</template>

<script>
import JCard from "@/components/JCard"
import JBaseDatePickerSimple from "@/components/JBaseDatePickerSimple"
import JBaseSelect from "@/components/JBaseSelect"
import JBaseInputText from "@/components/JBaseInputText"
import JBaseInputLongText from "@/components/JBaseInputLongText"
import JBaseInputNumber from "@/components/JBaseInputNumber"
import JButton from "@/components/JButton"
import JBaseToggle from "@/components/JBaseToggle"
import JBaseRadios from "@/components/JBaseRadios"
import CoreSelectCurrency from "@/modules/core/components/CoreSelectCurrency"

import api from "@/api/gql.js"
import { gql } from "@/api/utils.js"

// Returns a clone of an object
function deepClone(obj) {
	if (typeof obj !== "object") return obj
	if (obj === null) return null
	let clone = Object.assign({}, obj)
	Object.keys(clone).forEach(
		key =>
			(clone[key] =
				typeof obj[key] === "object" ? deepClone(obj[key]) : obj[key])
	)
	return Array.isArray(obj) && obj.length
		? (clone.length = obj.length) && Array.from(clone)
		: Array.isArray(obj)
		? Array.from(obj)
		: clone
}

export default {
	name: "AegClaimFact",
	components: {
		JCard,
		JBaseDatePickerSimple,
		JBaseSelect,
		JBaseInputText,
		JBaseInputLongText,
		JButton,
		JBaseToggle,
		JBaseInputNumber,
		JBaseRadios,
		CoreSelectCurrency
	},

	props: {
		id: {
			type: String
		}
	},

	created() {
		this.fetchFacts()
	},

	data() {
		return {
			isLoading: false,
			initialFacts: [],
			facts: []
		}
	},

	computed: {
		// Schema
		schema() {
			return {
				claim_reporting: [
					{
						label: "Loss Date",
						component: "JBaseDatePickerSimple",
						value: this.facts?.find(fact => fact.type === "lossDate")?.value
							?.dateValue,
						onInput: input => {
							this.upsertFact({
								type: "lossDate",
								input,
								fieldValue: "dateValue"
							})
						}
					},
					{
						label: "Loss Amount",
						component: "JBaseInputNumber",
						value: this.facts?.find(fact => fact.type === "lossAmount")?.value
							?.numberValue,
						onInput: input => {
							this.upsertFact({
								type: "lossAmount",
								input,
								fieldValue: "numberValue"
							})
						}
					},
					{
						label: "Loss Amount Currency",
						component: "CoreSelectCurrency",
						value: this.facts?.find(fact => fact.type === "lossAmountCurrency")
							?.value?.stringValue,
						onInput: input => {
							this.upsertFact({
								type: "lossAmountCurrency",
								input,
								fieldValue: "stringValue"
							})
						}
					},
					{
						label: "Reported Date",
						component: "JBaseDatePickerSimple",
						value: this.facts?.find(fact => fact.type === "reportedDate")?.value
							?.dateValue,
						onInput: input => {
							this.upsertFact({
								type: "reportedDate",
								input,
								fieldValue: "dateValue"
							})
						}
					},
					{
						label: "Within claims limit",
						component: "JBaseToggle",
						value: this.facts?.find(fact => fact.type === "withinClaimsLimit")
							?.value?.booleanValue,
						onInput: input => {
							this.upsertFact({
								type: "withinClaimsLimit",
								input,
								fieldValue: "booleanValue"
							})
						}
					},
					{
						label: "At premises",
						component: "JBaseToggle",
						value: this.facts?.find(fact => fact.type === "atPremises")?.value
							?.booleanValue,
						onInput: input => {
							this.upsertFact({
								type: "atPremises",
								input,
								fieldValue: "booleanValue"
							})
						}
					},
					{
						label: "Loss Country",
						component: "JBaseInputText",
						value: this.facts?.find(fact => fact.type === "lossCountry")?.value
							?.stringValue,
						onInput: input => {
							this.upsertFact({
								type: "lossCountry",
								input,
								fieldValue: "stringValue"
							})
						}
					},
					{
						label: "Loss City",
						component: "JBaseInputText",
						value: this.facts?.find(fact => fact.type === "lossCity")?.value
							?.stringValue,
						onInput: input => {
							this.upsertFact({
								type: "lossCity",
								input,
								fieldValue: "stringValue"
							})
						}
					},
					{
						label: "Cause of loss",
						component: "JBaseSelect",
						value: this.facts?.find(fact => fact.type === "causeOfLoss")?.value
							?.stringValue,
						componentProps: {
							options: [
								{
									value: "ARM- Armed Robbery",
									name: "ARM - Armed Robbery"
								},
								{
									value: "BUR- Burglary",
									name: "BUR - Burglary"
								},
								{
									value: "DOU - Doublet Stone",
									name: "DOU - Doublet Stone"
								},
								{
									value: "EXL- Lost in Exhibition",
									name: "EXL- Lost in Exhibition"
								},
								{
									value: "F.F.F. - Loss/Damage of Furnitures/Fixtures/Fittings",
									name: "F.F.F. - Loss/Damage of Furnitures/Fixtures/Fittings"
								},
								{
									value: "LOC- Loss of Cash",
									name: "LOC- Loss of Cash"
								},
								{
									value: "LOD - Loss of Diamond",
									name: "LOD - Loss of Diamond"
								},
								{
									value: "MYL - Mysterious Loss",
									name: "MYL - Mysterious Loss"
								},
								{
									value: "OFW - Overflowing of water from water cistern",
									name: "OFW - Overflowing of water from water cistern"
								},
								{
									value: "PDHL - Partial Damage / Loss via sending by DHL",
									name: "PDHL - Partial Damage / Loss via sending by DHL"
								},
								{
									value: "PFX - Partial Damage / Loss via sending by Fedex",
									name: "PFX - Partial Damage / Loss via sending by Fedex"
								},
								{
									value: "RDT - Robbery During Transit",
									name: "RDT - Robbery During Transit"
								},
								{
									value: "SDHL - Sending Damage / Loss by DHL",
									name: "SDHL - Sending Damage / Loss by DHL"
								},
								{
									value: "SFX - Sending Loss by Fedex",
									name: "SFX - Sending Loss by Fedex"
								},
								{
									value: "SHP - Shoplifting",
									name: "SHP - Shoplifting"
								},
								{
									value: "SIP - Sending Loss via IAP / RAP",
									name: "SIP - Sending Loss via IAP / RAP"
								},
								{
									value: "SNT - Snatch and run",
									name: "SNT - Snatch and run"
								},
								{
									value:
										"SSF - Partial Damage / Loss via sending by See Freight",
									name: "SSF - Partial Damage / Loss via sending by See Freight"
								},
								{
									value: "THT - Theft",
									name: "THT - Theft"
								},
								{
									value: "TNT - Sending Lost via TNT",
									name: "TNT - Sending Lost via TNT"
								},
								{
									value: "TOU - Tour Loss",
									name: "TOU - Tour Loss"
								},
								{
									value: "UPG - Loss of Unlawful Pawning of Goods",
									name: "UPG - Loss of Unlawful Pawning of Goods"
								},
								{
									value: "FIR - Fire Damage",
									name: "FIR - Fire Damage"
								},
								{
									value: "LOM - Loss of Memo Goods",
									name: "LOM - Loss of Memo Goods"
								},
								{
									value: "LOJ - Loss of Jewellery",
									name: "LOJ - Loss of Jewellery"
								},
								{
									value: "DIP - Damage to Insured's Property",
									name: "DIP - Damage to Insured's Property"
								},
								{
									value: "FID - Infidelity Loss",
									name: "FID - Infidelity Loss"
								},
								{
									value: "LDT - Loss During Transit",
									name: "LDT - Loss During Transit"
								},
								{
									value: "HRL - Home Risk Loss",
									name: "HRL - Home Risk Loss"
								},
								{
									value: "WD - Water Damage",
									name: "WD - Water Damage"
								},
								{
									value: "LDC - Loss Due to Carelessness",
									name: "LDC - Loss Due to Carelessness"
								}
							]
						},
						onInput: input => {
							this.upsertFact({
								type: "causeOfLoss",
								input,
								fieldValue: "stringValue"
							})
						}
					},
					{
						label: "Loss Details",
						component: "JBaseInputText",
						value: this.facts?.find(fact => fact.type === "lossDetails")?.value
							?.stringValue,
						onInput: input => {
							this.upsertFact({
								type: "lossDetails",
								input,
								fieldValue: "stringValue"
							})
						}
					}
				],
				settlement: [
					{
						label: "Settlement Date",
						component: "JBaseDatePickerSimple",
						value: this.facts?.find(fact => fact.type === "settlementDate")
							?.value?.dateValue,
						onInput: input => {
							this.upsertFact({
								type: "settlementDate",
								input,
								fieldValue: "dateValue"
							})
						}
					},
					{
						label: "Settlement Details",
						component: "JBaseInputLongText",
						value: this.facts?.find(fact => fact.type === "settlementDetails")
							?.value?.stringValue,
						componentProps: {
							rows: 4
						},
						onInput: input => {
							this.upsertFact({
								type: "settlementDetails",
								input,
								fieldValue: "stringValue"
							})
						}
					}
				],
				details: [
					{
						label: "Month of bordereaux declaration",
						component: "JBaseInputText",
						value: this.facts?.find(fact => fact.type === "monthBordereaux")
							?.value?.stringValue,
						onInput: input => {
							this.upsertFact({
								type: "monthBordereaux",
								input,
								fieldValue: "stringValue"
							})
						}
					},
					{
						label: "Year of bordereaux declaration",
						component: "JBaseInputText",
						value: this.facts?.find(fact => fact.type === "yearBordereaux")
							?.value?.stringValue,
						onInput: input => {
							this.upsertFact({
								type: "yearBordereaux",
								input,
								fieldValue: "stringValue"
							})
						}
					},
					{
						label: "Customer doc. number",
						component: "JBaseInputText",
						value: this.facts?.find(fact => fact.type === "customerDocNumber")
							?.value?.stringValue,
						onInput: input => {
							this.upsertFact({
								type: "customerDocNumber",
								input,
								fieldValue: "stringValue"
							})
						}
					},
					{
						label: "Coverage Brief Details",
						component: "JBaseInputText",
						value: this.facts?.find(
							fact => fact.type === "coverageBriefDetails"
						)?.value?.stringValue,
						onInput: input => {
							this.upsertFact({
								type: "coverageBriefDetails",
								input,
								fieldValue: "stringValue"
							})
						}
					}
				],
				recovery: [
					{
						isContainer: true,
						label: "Recovery 1",
						subItems: [
							{
								label: "Recovery 1 From",
								component: "JBaseInputText",
								value: this.facts?.find(fact => fact.type === "recoveryFrom1")
									?.value?.stringValue,
								onInput: input => {
									this.upsertFact({
										type: "recoveryFrom1",
										input,
										fieldValue: "stringValue"
									})
								}
							},
							{
								label: "Date",
								component: "JBaseDatePickerSimple",
								value: this.facts?.find(
									fact => fact.type === "recoveryFrom1Date"
								)?.value?.dateValue,
								onInput: input => {
									this.upsertFact({
										type: "recoveryFrom1Date",
										input,
										fieldValue: "dateValue"
									})
								}
							},
							{
								label: "Amount",
								component: "JBaseInputNumber",
								value: this.facts?.find(
									fact => fact.type === "recoveryFrom1Amount"
								)?.value?.numberValue,
								onInput: input => {
									this.upsertFact({
										type: "recoveryFrom1Amount",
										input,
										fieldValue: "numberValue"
									})
								}
							}
						]
					},
					{
						isContainer: true,
						label: "Recovery 2",
						subItems: [
							{
								label: "Recovery 2 From",
								component: "JBaseInputText",
								value: this.facts?.find(fact => fact.type === "recoveryFrom2")
									?.value?.stringValue,
								onInput: input => {
									this.upsertFact({
										type: "recoveryFrom2",
										input,
										fieldValue: "stringValue"
									})
								}
							},
							{
								label: "Date",
								component: "JBaseDatePickerSimple",
								value: this.facts?.find(
									fact => fact.type === "recoveryFrom2Date"
								)?.value?.dateValue,
								onInput: input => {
									this.upsertFact({
										type: "recoveryFrom2Date",
										input,
										fieldValue: "dateValue"
									})
								}
							},
							{
								label: "Amount",
								component: "JBaseInputNumber",
								value: this.facts?.find(
									fact => fact.type === "recoveryFrom2Amount"
								)?.value?.numberValue,
								onInput: input => {
									this.upsertFact({
										type: "recoveryFrom2Amount",
										input,
										fieldValue: "numberValue"
									})
								}
							}
						]
					}
				],
				loss_adjuster: [
					{
						label: "Loss Adjuster Appointed By",
						component: "JBaseRadios",
						value: this.facts?.find(
							fact => fact.type === "lossAdjusterAppointedBy"
						)?.value?.stringValue,
						componentProps: {
							options: [
								{ value: "anglo east", name: "Anglo East" },
								{ value: "underwriter", name: "Underwriter" }
							]
						},
						onInput: input => {
							this.upsertFact({
								type: "lossAdjusterAppointedBy",
								input,
								fieldValue: "stringValue"
							})
						}
					},
					{
						label: "Loss Adjuster",
						component: "JBaseInputText",
						value: this.facts?.find(fact => fact.type === "lossAdjusterName")
							?.value?.stringValue,
						onInput: input => {
							this.upsertFact({
								type: "lossAdjusterName",
								input,
								fieldValue: "stringValue"
							})
						}
					},
					{
						label: "Loss Adjustement Date",
						component: "JBaseDatePickerSimple",
						value: this.facts?.find(fact => fact.type === "lossAdjustementDate")
							?.value?.dateValue,
						onInput: input => {
							this.upsertFact({
								type: "lossAdjustementDate",
								input,
								fieldValue: "dateValue"
							})
						}
					}
				],
				fees: [
					{
						isContainer: true,
						label: "Adjuster Fee",
						subItems: [
							{
								label: "Adjuster Fee",
								isDoubleComponent: true,
								firstComponent: {
									component: "CoreSelectCurrency",
									value: this.facts?.find(
										fact => fact.type === "adjusterFeeCurrency"
									)?.value?.stringValue,
									onInput: input => {
										this.upsertFact({
											type: "adjusterFeeCurrency",
											input,
											fieldValue: "stringValue"
										})
									}
								},
								secondComponent: {
									component: "JBaseInputNumber",
									value: this.facts?.find(fact => fact.type === "adjusterFee")
										?.value?.numberValue,
									onInput: input => {
										this.upsertFact({
											type: "adjusterFee",
											input,
											fieldValue: "numberValue"
										})
									}
								}
							},
							{
								label: "Debit Note",
								component: "JBaseInputText",
								value: this.facts?.find(
									fact => fact.type === "adjusterFeeDebitNote"
								)?.value?.stringValue,
								onInput: input => {
									this.upsertFact({
										type: "adjusterFeeDebitNote",
										input,
										fieldValue: "stringValue"
									})
								}
							},
							{
								label: "Date",
								component: "JBaseDatePickerSimple",
								value: this.facts?.find(fact => fact.type === "adjusterFeeDate")
									?.value?.dateValue,
								onInput: input => {
									this.upsertFact({
										type: "adjusterFeeDate",
										input,
										fieldValue: "dateValue"
									})
								}
							},
							{
								label: "Paid By",
								component: "JBaseInputText",
								value: this.facts?.find(
									fact => fact.type === "adjusterFeePaidBy"
								)?.value?.stringValue,
								onInput: input => {
									this.upsertFact({
										type: "adjusterFeePaidBy",
										input,
										fieldValue: "stringValue"
									})
								}
							},
							{
								label: "Cheque No.",
								component: "JBaseInputText",
								value: this.facts?.find(
									fact => fact.type === "adjusterFeeCheque"
								)?.value?.stringValue,
								onInput: input => {
									this.upsertFact({
										type: "adjusterFeeCheque",
										input,
										fieldValue: "stringValue"
									})
								}
							},
							{
								label: "Cheque Date",
								component: "JBaseDatePickerSimple",
								value: this.facts?.find(
									fact => fact.type === "adjusterFeeChequeDate"
								)?.value?.dateValue,
								onInput: input => {
									this.upsertFact({
										type: "adjusterFeeChequeDate",
										input,
										fieldValue: "dateValue"
									})
								}
							}
						]
					},
					{
						isContainer: true,
						label: "Legal Fee",
						subItems: [
							{
								label: "Legal Fee",
								isDoubleComponent: true,
								firstComponent: {
									component: "CoreSelectCurrency",
									value: this.facts?.find(
										fact => fact.type === "legalFeeCurrency"
									)?.value?.stringValue,
									onInput: input => {
										this.upsertFact({
											type: "legalFeeCurrency",
											input,
											fieldValue: "stringValue"
										})
									}
								},
								secondComponent: {
									component: "JBaseInputNumber",
									value: this.facts?.find(fact => fact.type === "legalFee")
										?.value?.numberValue,
									onInput: input => {
										this.upsertFact({
											type: "legalFee",
											input,
											fieldValue: "numberValue"
										})
									}
								}
							},
							{
								label: "Debit Note",
								component: "JBaseInputText",
								value: this.facts?.find(
									fact => fact.type === "legalFeeDebitNote"
								)?.value?.stringValue,
								onInput: input => {
									this.upsertFact({
										type: "legalFeeDebitNote",
										input,
										fieldValue: "stringValue"
									})
								}
							},
							{
								label: "Date",
								component: "JBaseDatePickerSimple",
								value: this.facts?.find(fact => fact.type === "legalFeeDate")
									?.value?.dateValue,
								onInput: input => {
									this.upsertFact({
										type: "administrativeFee1Date",
										input,
										fieldValue: "dateValue"
									})
								}
							},
							{
								label: "Paid By",
								component: "JBaseInputText",
								value: this.facts?.find(fact => fact.type === "legalFeePaidBy")
									?.value?.stringValue,
								onInput: input => {
									this.upsertFact({
										type: "administrativeFee1PaidBy",
										input,
										fieldValue: "stringValue"
									})
								}
							},
							{
								label: "Cheque No.",
								component: "JBaseInputText",
								value: this.facts?.find(fact => fact.type === "legalFeeCheque")
									?.value?.stringValue,
								onInput: input => {
									this.upsertFact({
										type: "legalFeeCheque",
										input,
										fieldValue: "stringValue"
									})
								}
							},
							{
								label: "Cheque Date",
								component: "JBaseDatePickerSimple",
								value: this.facts?.find(
									fact => fact.type === "legalFeeChequeDate"
								)?.value?.dateValue,
								onInput: input => {
									this.upsertFact({
										type: "legalFeeChequeDate",
										input,
										fieldValue: "dateValue"
									})
								}
							}
						]
					}
				],
				solicitor_details: [
					{
						label: "no_label",
						component: "JBaseInputLongText",
						value: this.facts?.find(fact => fact.type === "solicitorDetails")
							?.value?.stringValue,
						onInput: input => {
							this.upsertFact({
								type: "solicitorDetails",
								input,
								fieldValue: "stringValue"
							})
						}
					}
				]
			}
		}
	},

	methods: {
		async saveFacts() {
			const query = gql`
				mutation claimFactBatch($input: factBatchInput!, $claimId: ID!) {
					claimFactBatch(input: $input, claimId: $claimId) {
						status
						errors
					}
				}
			`
			const factsToAdd = this.factsToAdd()
			const formattedFactsToAdd = factsToAdd.map(function(fact) {
				return { type: fact.type, value: fact.value }
			})
			const variables = {
				input: {
					addFactInputs: formattedFactsToAdd,
					updateFactInputs: this.factsToUpdate()
				},
				claimId: this.id
			}

			this.isLoading = true
			const res = await api({ query, variables })

			if (res?.data?.claimFactBatch?.status !== "success") {
				this.$store.dispatch(
					"showError",
					res?.data?.claimFactBatch?.errors[0] || this.$t("errors.general")
				)
				this.isLoading = false
				return
			}
			this.$store.dispatch("addMessage", {
				message: { type: "success", text: this.$t("claim_facts_saved") }
			})
			this.isLoading = false
			this.fetchFacts()
		},

		// Returns facts that where already here but the value changed
		factsToUpdate() {
			return this.facts.filter(fact => {
				const initialFact = this.initialFacts.find(initialFact => {
					return initialFact.type === fact.type
				})
				return (
					initialFact &&
					JSON.stringify(initialFact.value) !== JSON.stringify(fact.value)
				)
			})
		},

		// Returns facts that were not already here
		factsToAdd() {
			return this.facts.filter(fact => {
				const initialFact = this.initialFacts.find(initialFact => {
					return initialFact.type === fact.type
				})
				return !initialFact
			})
		},

		// Add new fact if the type is not in this.facts or update the value
		upsertFact({ type, input, fieldValue }) {
			let fact = this.facts?.find(fact => fact.type === type)
			if (fact) {
				fact.value
					? (fact.value[fieldValue] = input)
					: (fact.value = { [fieldValue]: input })
			} else {
				this.facts.push({
					type,
					value: {
						[fieldValue]: input
					}
				})
			}
		},

		// Fetch facts and set this.facts, and clone into this.initialFacts
		async fetchFacts() {
			const query = gql`
				query claim($where: claimWhereInput) {
					claims(where: $where) {
						list {
							id
							facts {
								id
								type
								value {
									stringValue
									booleanValue
									numberValue
									dateValue
									arrayValue {
										stringValue
										booleanValue
										numberValue
										dateValue
									}
								}
							}
						}
					}
				}
			`

			const variables = {
				where: {
					id: this.id
				}
			}

			this.isLoading = true
			const res = await api({ variables, query })

			if (res?.data?.claims?.list[0]) {
				this.facts = res.data.claims.list[0]?.facts || []
				this.initialFacts = deepClone(this.facts)
			} else {
				this.$store.dispatch("showError", this.$t("errors.general"))
			}

			// Succes - redirect
			this.isLoading = false
		}
	}
}
</script>
